module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "Mails"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9 "
  }, [_c('div', {
    staticClass: "card standard-card stats-card"
  }, [_c('complete-process')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f177fad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/processLead.vue
// module id = 391
// module chunks = 0